import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';
import { compose } from 'underscore';

import AutomationWorkflowWizard from 'blocks/AutomationWorkflowWizard';
import { userIsAuthenticatedAndOnboarded } from 'components/hoc/auth';
import withRouter from 'components/hoc/withRouter';
import {
  AudiogramWizard,
  AudioWizard,
  AutomatedWizard,
  EpisodeWizard,
  TemplateWizard,
  TextWizard,
  VideoWizard,
} from 'containers/ProjectWizards';
import VideoClipWizard from 'containers/ProjectWizards/VideoClipWizard';
import withRedirectOnMobile from 'containers/Redirect/withRedirectOnMobile';
import { appHomeSelector } from 'redux/modules/router';
import { parseSearch } from 'utils/routes';

const withAuth = compose(withRouter, userIsAuthenticatedAndOnboarded);
const withAuthOnDesktop = compose(withAuth, withRedirectOnMobile());

const AuthAudiogramWizard = withAuthOnDesktop(AudiogramWizard);
const AuthAutomatedWizard = withAuthOnDesktop(AutomatedWizard);
const AuthEpisodeWizard = withAuthOnDesktop(EpisodeWizard);
const AuthTextWizard = withAuthOnDesktop(TextWizard);
const AuthVideoWizard = withAuthOnDesktop(VideoWizard);
const AuthTemplateWizard = withAuthOnDesktop(TemplateWizard);
const AuthAutogramWizard = withAuth(AutomationWorkflowWizard);

const WizardPage: React.FC = () => {
  const fallbackUrl = useSelector(appHomeSelector);

  const { search, state } = useLocation();
  const { type } = parseSearch(search);

  switch (type) {
    case 'audio':
      return <AudioWizard />;

    case 'video-clip':
      return <VideoClipWizard />;

    case 'audiogram':
      return <AuthAudiogramWizard />;

    case 'automated':
      return <AuthAutomatedWizard />;

    case 'episode':
      return <AuthEpisodeWizard />;

    case 'text':
      return <AuthTextWizard />;

    case 'video-transcription':
      return <AuthVideoWizard />;

    case 'template':
      return <AuthTemplateWizard />;

    case 'autovideo':
      return <AuthAutogramWizard key={state} />;

    default:
      return <Redirect to={fallbackUrl} />;
  }
};

export default WizardPage;
